import React from "react";
import { connect } from "react-redux";
import { List, Button, Tabs, Popover, Popup, TextArea } from 'devextreme-react';
import Moment from "moment";
import { showToastError, showMessageApi } from "../../../../Main/actions";
import trace from "../../../../../helpers/trace";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import TablaAprobadores from "./tablaAprobadores";
import TablaConvenios from "./tablaConvenios";
import TablaBaterias from "./tablaBaterias";
import TablaDescuentos from "./tablaDescuentos";
import { setEmpresa } from "./action";

class DetailEmpresaDataGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {    
      selectedIndex: 0,
      tooltipAyuda: false,
      selectedItemKeys: [],
      selectedItems: null,
      selectedTabEmpresaState: null,
      confirmSavePopup: false,
      confirmCancelPopup: false,
      popoverSaveDiscard: false,
      rejectSavePopup: false,
      rejectModal: false,
      textAreaRejectModal: "",
      empresa: this.props.data,
    };
    this.onTabsSelectionChanged = this.onTabsSelectionChanged.bind(this);
  }

  onTabsSelectionChanged = (args) => {    
    if(args.name == 'selectedIndex' && args.element.id === "tabInboxEmpresa" && args.value >= 0) {
      this.setState({
        selectedIndex: args.value
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="contenedor-tabInboxEmpresa">
          <Tabs
            id="tabInboxEmpresa"
            dataSource={[
              { text: 'Aprobadores ' },
              { text: 'Baterias ' },
              { text: 'Descuentos ' },
              { text: 'Convenios ' }
            ]}
            selectedIndex={this.state.selectedIndex || 0}
            onOptionChanged={this.onTabsSelectionChanged}
            scrollByContent={false}
            showNavButtons={false}
            focusStateEnabled={false}
            hoverStateEnabled={false}
            activeStateEnabled={false}
          />
          
            {this.state.selectedIndex === 0 && <TablaAprobadores data={this.state.empresa}/>}
            {this.state.selectedIndex === 1 && <TablaBaterias />}
            {this.state.selectedIndex === 2 && <TablaDescuentos />}
            {this.state.selectedIndex === 3 && <TablaConvenios data={this.state.empresa}/>}
        </div>
      </React.Fragment>
    );
  }

}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorEmpresas.isLoading,
  listaEmpresas: state.mantenedorEmpresas.listaEmpresas,
  listaEmpresasFiltradas: state.mantenedorEmpresas.listaEmpresasFiltradas,
  filtrosEmpresas: state.mantenedorEmpresas.filtrosEmpresas,
  empresa: state.mantenedorEmpresas.empresa,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailEmpresaDataGrid);